// Global variables to track video states
let mainVideoPlayer = null;
let storyVideoPlayers = {};

// Function to play/pause main video
function playMainVideo(videoId) {
  if (!videoId) return;
  
  const container = document.querySelector('.main-video-container');
  const thumbnail = container.querySelector('.main-video-thumbnail');
  const iframeContainer = container.querySelector('.video-iframe-container');
  const iframe = container.querySelector('#main-video-iframe');
  
  if (iframeContainer.style.display === 'none') {
    // Play video
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1`;
    iframe.src = embedUrl;
    thumbnail.style.display = 'none';
    iframeContainer.style.display = 'block';
  } else {
    // Stop video
    iframe.src = '';
    thumbnail.style.display = 'block';
    iframeContainer.style.display = 'none';
  }
}

// Function to play/pause story videos
function playStoryVideo(videoId, element) {
  if (!videoId) return;
  
  const container = element.closest('.video-story-container');
  const thumbnail = container.querySelector('.video-story-thumbnail');
  const iframeContainer = container.querySelector('.video-story-iframe-container');
  const iframe = iframeContainer.querySelector('iframe');
  
  if (iframeContainer.style.display === 'none') {
    // Stop all other story videos first
    document.querySelectorAll('.video-story-iframe-container').forEach(function(otherContainer) {
      if (otherContainer !== iframeContainer && otherContainer.style.display === 'block') {
        otherContainer.querySelector('iframe').src = '';
        otherContainer.style.display = 'none';
        otherContainer.closest('.video-story-container').querySelector('.video-story-thumbnail').style.display = 'block';
      }
    });
    
    // Play this video
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1`;
    iframe.src = embedUrl;
    thumbnail.style.display = 'none';
    iframeContainer.style.display = 'block';
  } else {
    // Stop this video
    iframe.src = '';
    thumbnail.style.display = 'block';
    iframeContainer.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit to ensure Splide is loaded
  setTimeout(function() {
    // Check if Splide is available
    if (typeof Splide === 'undefined') {
      console.error('Splide library is not loaded. Please include Splide CSS and JS files.');
      return;
    }

    // Initialize Splide slider
    const splideElement = document.querySelector('#video-stories-{{ section.id }}');
    const videoStoriesWrapper = document.querySelector('.video-stories-wrapper');
    const totalSlides = document.querySelectorAll('.video-story-item').length;
    
    if (splideElement && totalSlides > 0) {
      let perPage = 4;
      let gap = '48px';
      let showArrows = false;
      
      // Check if we need to show arrows and adjust settings based on screen size
      if (window.innerWidth <= 768) {
        perPage = 1.15; // Show one full slide and small part of the next
        gap = '16px';
        showArrows = totalSlides > 1;
      } else {
        perPage = Math.min(4, totalSlides);
        gap = '48px';
        showArrows = totalSlides > 4;
      }
      
      // Add data attribute for styling
      if (showArrows) {
        videoStoriesWrapper.setAttribute('data-show-arrows', 'true');
      }
      
      try {
        const splide = new Splide(splideElement, {
          type: 'slide',
          perPage: perPage,
          perMove: 1,
          gap: gap,
          pagination: false,
          arrows: showArrows,
          drag: showArrows || window.innerWidth <= 768,
          focus: 0,
          omitEnd: true,
          breakpoints: {
            768: {
              perPage: 1.15,
              gap: '0px',
              arrows: totalSlides > 1,
              drag: true
            }
          }
        });
        
        splide.mount();
        
        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            const newTotalSlides = document.querySelectorAll('.video-story-item').length;
            let newShowArrows = false;
            
            if (window.innerWidth <= 768) {
              newShowArrows = newTotalSlides > 1;
            } else {
              newShowArrows = newTotalSlides > 4;
            }
            
            if (newShowArrows) {
              videoStoriesWrapper.setAttribute('data-show-arrows', 'true');
            } else {
              videoStoriesWrapper.removeAttribute('data-show-arrows');
            }
          }, 250);
        });
      } catch (error) {
        console.error('Error initializing Splide:', error);
      }
    }
  }, 100);
});
